import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { SceneEmail } from '@elem/compCommon/SceneEmail';

export default function A() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const IMG_MAP: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760082013137/pc_kv.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760089077467/Mob.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760082013137/pc_kv.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760089077467/Mob.jpg',
        },
    };
    return (
        <div className={`power-backup-A ${css['power-backup-A']}`}>
            <EcoImg pc={IMG_MAP[locale].pc} h5={IMG_MAP[locale].h5} alt={t('secA_title')} aria-label={t('secA_title')} />
            <div className="info">
                <p className="title">{t('secA_title')}</p>
                <SceneEmail theme="white" type="BATTERY_BACKUP" title={t('secA_title')} />
            </div>
        </div>
    );
}
